import { createSlice } from '@reduxjs/toolkit';
import { GoalListState } from './goallistTypes';
import { createGoallist , UpdateGoallist , fetchAllGoallist , fetchGoallistById ,deleteGoallist } from './goallistAction';


const initialState : GoalListState = {
    goallist : [],
    selectedgoallist : undefined,
    loadingStates : {
        create: false,
        update: false,
        delete: false,
        fetchById: false,
        fetchAll: false,
    },
    errors: {
        create: undefined,
        update: undefined,
        delete: undefined,
        fetchById: undefined,
        fetchAll: undefined,
    },
}


const goallistSlice = createSlice({
    name : 'goallist',
    initialState,
    reducers:{},
    extraReducers : (builder) =>{
        builder
            .addCase(createGoallist.pending, (state) => {
                                              state.loadingStates.create = true;
                                              state.errors.create = undefined;
                                          })
                                          .addCase(createGoallist.fulfilled, (state, action) => {
                                              state.loadingStates.create = false;
                                              state.goallist.push(action.payload);
                                          })
                                          .addCase(createGoallist.rejected, (state, action) => {
                                              state.loadingStates.create = false;
                                              state.errors.create = action.payload as string;
                                          })
                              
                                          // Update 
                                          .addCase(UpdateGoallist .pending, (state) => {
                                              state.loadingStates.update = true;
                                              state.errors.update = undefined;
                                          })
                                          .addCase(UpdateGoallist .fulfilled, (state, action) => {
                                              state.loadingStates.update = false;
                                              const index = state.goallist.findIndex((d : any) => d.Id === action.payload.Id);
                                              if (index !== -1) {
                                                  state.goallist[index] = action.payload;
                                              }
                                          })
                                          .addCase(UpdateGoallist .rejected, (state, action) => {
                                              state.loadingStates.update = false;
                                              state.errors.update = action.payload as string;
                                          })
                              
                                          // Delete 
                                          .addCase(deleteGoallist.pending, (state) => {
                                              state.loadingStates.delete = true;
                                              state.errors.delete = undefined;
                                          })
                                          .addCase(deleteGoallist.fulfilled, (state, action) => {
                                              state.loadingStates.delete = false;
                                              state.goallist = state.goallist.filter((d : any) => d.Id !== action.payload);
                                          })
                                          .addCase(deleteGoallist.rejected, (state, action) => {
                                              state.loadingStates.delete = false;
                                              state.errors.delete = action.payload as string;
                                          })
                              
                                          // Fetch  by ID
                                          .addCase(fetchGoallistById.pending, (state) => {
                                              state.loadingStates.fetchById = true;
                                              state.errors.fetchById = undefined;
                                          })
                                          .addCase(fetchGoallistById.fulfilled, (state, action) => {
                                              state.loadingStates.fetchById = false;
                                              state.selectedgoallist = action.payload;
                                          })
                                          .addCase(fetchGoallistById.rejected, (state, action) => {
                                              state.loadingStates.fetchById = false;
                                              state.errors.fetchById = action.payload as string;
                                          })
                              
                                          // Fetch All 
                                          .addCase(fetchAllGoallist.pending, (state) => {
                                              state.loadingStates.fetchAll = true;
                                              state.errors.fetchAll = undefined;
                                          })
                                          .addCase(fetchAllGoallist.fulfilled, (state, action) => {
                                              state.loadingStates.fetchAll = false;
                                              state.goallist = action.payload.data;
                                          })
                                          .addCase(fetchAllGoallist.rejected, (state, action) => {
                                              state.loadingStates.fetchAll = false;
                                              state.errors.fetchAll = action.payload as string;
                                          }); 
    }
})


export default goallistSlice.reducer;